import { createSlice } from '@reduxjs/toolkit'
import { AppsSchema } from '../types/Apps'
import { ApplicationState } from '../../../../entities/Application'
import { fetchApps } from '../services/fetchApps'

const initialState: AppsSchema = {
	limit: 10,
	isLoading: false,
	error: '',

	state: ApplicationState._,
	paginatedApps: {
		currentPage: 1,
		items: []
	},
	queryFilter: {},
	filter: {},
	sort: {}
}

const appsSlice = createSlice({
	name: 'applications',
	initialState,
	reducers: {
		setPage: (state, action) => {
			state.paginatedApps.currentPage = action.payload
		},
		setLimit: (state, action) => {
			state.limit = action.payload
		},
		setDirection: (state, action) => {
			state.sort.direction = action.payload
		},
		setSort: (state, action) => {
			state.sort.sort = action.payload
		},
		setState: (state, action) => {
			state.state = action.payload
		},
		setQueryFilter: (state) => {
			state.queryFilter = { ...state.filter }
		},
		setUserName: (state, action) => {
			state.filter.userName = action.payload
		},
		setCreationDateFrom: (state, action) => {
			state.filter.creationDateFrom = action.payload
		},
		setCreationDateTo: (state, action) => {
			state.filter.creationDateTo = action.payload
		},
		setExpirationDateFrom: (state, action) => {
			state.filter.expirationDateFrom = action.payload
		},
		setExpirationDateTo: (state, action) => {
			state.filter.expirationDateTo = action.payload
		},
		removeFilter: (state, action) => {
			const filterName: keyof typeof state.queryFilter = action.payload
			delete state.filter[filterName]
			delete state.queryFilter[filterName]
		},
		resetFilter: (state) => {
			state.filter = {}
			state.queryFilter = {}
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchApps.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchApps.fulfilled, (state, action) => {
				state.isLoading = false
				state.paginatedApps = action.payload
			})
			.addCase(fetchApps.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: appsActions } = appsSlice
export const { reducer: appsReducer } = appsSlice
